'use client';
import { useState } from 'react';
import { getRemainingTime, getRemainingMSeconds } from '@/utils/date/difference-between-times';
import { useInterval } from '@/hooks/use-interval';
import { getTile } from '../../utils/countdown-helpers';
import './styles/default.scss';

type CountDownTimerExclusiveProps = {
    launchDate: string;
    offset: number;
    url?: string;
    size?: 'small' | 'medium' | 'large';
};
/**
 * Display a timer indicating the remaining time for an upcoming event or deadline
 * @param {number} Props.offset - The vertical offset between digits.
 * @param {string} [Props.url=''] - The URL (optional) for digits' background.
 * @param {'small' | 'medium' | 'large'} [Props.size='small'] - The size variant of the timer. Medium is for popup, large is for landscape, small is for portrait.
 */
export const CountDownTimerExclusive = ({
    launchDate,
    offset,
    url = '',
    size = 'small'
}: CountDownTimerExclusiveProps) => {
    let timeLeftInMSeconds = getRemainingMSeconds(launchDate);
    const [remainingTime, setRemainingTime] = useState(timeLeftInMSeconds || 0);
    const { days, hours, minutes, seconds } = getRemainingTime(remainingTime);

    const [remainingDays, setRemainingDays] = useState(days || 0);
    const [remainingHours, setRemainingHours] = useState(hours || 0);
    const [remainingMinutes, setRemainingMinutes] = useState(minutes || 0);
    const [remainingSeconds, setRemainingSeconds] = useState(seconds || 0);

    useInterval(
        () => {
            timeLeftInMSeconds = getRemainingMSeconds(launchDate) || 0;
            const newTime = getRemainingTime(timeLeftInMSeconds);
            setRemainingTime(timeLeftInMSeconds);
            setRemainingDays(newTime.days || 0);
            setRemainingHours(newTime.hours || 0);
            setRemainingMinutes(newTime.minutes || 0);
            setRemainingSeconds(newTime.seconds || 0);
        },
        remainingTime > 0 ? 250 : 0
    );

    if (timeLeftInMSeconds === null) {
        return null;
    }

    return (
        <div className={`timer__container timer__container--${size}`}>
            {getTile(url, offset, remainingDays, 'days')}
            {getTile(url, offset, remainingHours, 'hrs')}
            {getTile(url, offset, remainingMinutes, 'min')}
            {getTile(url, offset, remainingSeconds, 'sec')}
        </div>
    );
};
